module.exports = __webpack_public_path__ + "bg.no2.1aaca360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bg.no2.jpg
// module id = okVh
// module chunks = 0